import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSeo } from "../lib/seo";
import { trackPageView } from "../lib/analytics";

export function Seo(props) {
  useSeo(props);
  return null;
}

export function PageViewTracker() {
  const { pathname } = useLocation();
  useEffect(() => { trackPageView(pathname); }, [pathname]);
  return null;
}
